module.exports = __webpack_public_path__ + "static/img/comm.5116324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comm.png
// module id = 3CfJ
// module chunks = 0